import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";
import ListItem from "./followListItem";

const Listing = ({ list, fetchList }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.listing}>
      <div className={styles.tableHeader}>
        <span className={styles.colTopic}>{t("followed_topics_page.topic_name", "Topic Name")}</span>
        <span className={styles.colDashboard}>{t("followed_topics_page.dashboard", "Dashboard")}</span>
        <span className={styles.colActions} />
      </div>
      <div className={styles.tableBody}>
        {list.map((item, idx) => (
          <ListItem key={item.topic_id || idx} item={item} fetchList={fetchList} />
        ))}
      </div>
    </div>
  );
};

export default Listing;
